import { CogsIcon } from './CogsIcon';

/**
 * author: Google
 * id 2EF56130-ECE9-4432-B59E-36F646DE1C86
 * name cogs
 * version: 2.3.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cogs.svg
 * tags
 * - Settings 
 */
export const ManufacturingIcon = CogsIcon;
export default ManufacturingIcon